<template>
	<v-layout
		row
		wrap
		justify-center
	>
		<v-flex xl8>
			<v-data-iterator
				ref="iterator"
				:items="items"
				:pagination.sync="pagination"
				:hide-actions="items.length === 0"
				no-data-text="No custom fields available"
				no-results-text="No matching custom fields found"
				content-tag="v-layout"
				row
				wrap
				justify-center
			>
				<v-flex
					slot="item"
					slot-scope="props"
					xs12
				>
					<v-card :class="{disabled_field: props.item.disabled}">
						<v-container>
							<v-layout
								row
								wrap
								align-center
								justify-end
								px-3
							>
								<div>
									<div class="headline pb-2">{{ props.item.label }}</div>
									<div class="subheading">{{ props.item.typeText }}</div>
								</div>
								<v-spacer />
								<div v-if="canEdit">
									<v-btn
										v-if="!props.item.disabled"
										flat
										@click="$emit('update', props.item)"
									>
										Update
									</v-btn>
									<v-btn
										v-if="!props.item.disabled"
										flat
										color="error"
										@click="$emit('disable', props.item)"
									>
										Disable
									</v-btn>
									<v-btn
										v-if="props.item.disabled"
										flat
										color="success"
										@click="$emit('disable', props.item)"
									>
										Enable
									</v-btn>
								</div>
							</v-layout>
							
							<CustomFieldItems
								v-if="props.item.showItems"
								:custom-field="props.item"
							/>
							
						</v-container>
					</v-card>
				</v-flex>
			</v-data-iterator>
		</v-flex>
	</v-layout>
</template>

<script>
import CustomFieldItems from '@/components/Project/CustomFields/CustomFieldItems';

export default {
	components: {
		CustomFieldItems,
	},
	
	props: {
		items: {
			type: Array,
			default: null
		},
	},
	
	data() {
		return {
			pagination: {
				rowsPerPage: 12,
				sortBy: 'name',
				descending: false,
				page: 1,
			},
		};
	},
	
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		
		canEdit() {
			return this.project.userCan('manage_custom_data') && !this.project.isArchived;
		},
	},
	
	methods: {
		
	},
};
</script>

<style lang="scss" scoped>
.small-btn {
	margin-top: 0;
	margin-right: -10px;
	margin-bottom: 0;
}
.absolute--right {
	position: absolute;
	top: 0;
	right: 0;
}
.disabled_field {
	opacity: 0.5;
}
</style>
